module.exports = __webpack_public_path__ + "img/i5gamBanner230412-1.bbae0c85.png";